import React from "react"
import { useTranslation } from "react-i18next"

import {
  calculateTotalTaxes,
  calculateItemSalePrice,
  roundNumber,
  thousandSeparator
} from "utils"
import OrderDetailsTaxes from "./OrderDetailsTaxes"
import classes from "./OrderDetailsFooter.module.scss"

const OrderDetailsFooter = props => {
  const { order } = props

  const [t] = useTranslation()

  const {
    items,
    deliveryFee,
    deliveryType,
    deliveryDiscount = 0,
    foodDiscount = 0
  } = order

  const isShipping = deliveryType === "delivery"

  const subtotal =
    items.reduce((t, item) => (
      t +=
      (calculateItemSalePrice(item) * item.quantity) +
      item.totalSpecificationSalePrice
    ), 0)

  const totalSystemDiscounts =
    items.reduce((t, item) => (
      t += item.systemDiscount > 0 ? item.systemDiscount : 0
    ), 0)

  const totalDiscount =
    totalSystemDiscounts +
    deliveryDiscount +
    foodDiscount

  const totalTaxes =
    calculateTotalTaxes(order)

  const totalBeforeRounding =
    subtotal +
    totalTaxes +
    deliveryFee -
    totalDiscount

  const total =
    roundNumber(
      totalBeforeRounding
    )

  return (
    <div className={classes["container"]}>
      <div className={classes["totalItem"]}>
        <span>{t("مجموع_اقلام")}</span>
        <span className={classes["number"]}>
          {thousandSeparator(subtotal)}
        </span>
      </div>
      {
        isShipping &&
        <div className={classes["deliveryFeeContainer"]}>
          <div className={classes["deliveryFee"]}>
            <span>{t("هزینه_ارسال")}</span>
            <span className={classes["number"]}>
              {thousandSeparator(deliveryFee)}
            </span>
          </div>
        </div>
      }
      {
        totalSystemDiscounts > 0 &&
        <div className={classes["totalItem"]}>
          <span>{t("تخفیف_صندوقدار")}</span>
          <span className={classes["number"]}>
            {thousandSeparator(-totalSystemDiscounts)}
          </span>
        </div>
      }
      {
        foodDiscount > 0 &&
        <div className={classes["totalItem"]}>
          <span>{t("تخفیف_کالا")}</span>
          <span className={classes["number"]}>
            {thousandSeparator(-foodDiscount)}
          </span>
        </div>
      }
      {
        deliveryDiscount > 0 &&
        <div className={classes["totalItem"]}>
          <span>{t("تخفیف_ارسال")}</span>
          <span className={classes["number"]}>
            {thousandSeparator(-deliveryDiscount)}
          </span>
        </div>
      }
      <OrderDetailsTaxes
        order={order}
      />
      <div className={classes["total"]}>
        <span>{t("مجموع")}</span>
        <b className={classes["totalNumber"]}>
          {thousandSeparator(total)}
        </b>
      </div>
    </div>
  )
}

export default OrderDetailsFooter